import React from 'react';
import buildVersion from '../../version';
import InternalLink from './internal-link';

class AdditionalStickyButtons extends React.Component {
  state = {
    clsName: 'btn-sport-client-sticky'
  };

  handleClick = () => {
    if (this.state.clsName.includes('extended-sticky')) {
      this.setState({ clsName:'btn-sport-client-sticky' });
    } else {
      this.setState({ clsName:'btn-sport-client-sticky extended-sticky' });
    }
  };

  render() {
    return (
      <ul className={this.state.clsName} onClick={() => this.handleClick()}>
        <li className="test-label"><strong>TEST SITE</strong></li>
        <li className="build-version-number-sticky"><span>Build-Version: {buildVersion}</span></li>
        <li><InternalLink to="/test-page-cta">Test CTA</InternalLink></li>
        <li><InternalLink to="/general-test-page">Odds/Currency/Clickstream</InternalLink></li>
        <li><InternalLink to="/888event">Event page</InternalLink></li>
      </ul>
    );
  }
}

export default AdditionalStickyButtons;
